import { render, staticRenderFns } from "./EditCompanyRegistryModal.vue?vue&type=template&id=36ef8925&scoped=true&"
import script from "./EditCompanyRegistryModal.vue?vue&type=script&lang=ts&"
export * from "./EditCompanyRegistryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef8925",
  null
  
)

export default component.exports